export const ptBRDashboard = {
  welcome: 'Bem-vindo, {{name}}',
  welcomeFallbackName: 'Usuário',
  upcomingBillsHeading: 'Contas a Vencer',
  upcomingBillsLoading: 'Carregando contas...',
  upcomingBillsError: 'Falha ao carregar contas',
  due3Days: 'Vence em 3 Dias',
  overdue30Plus: 'Vencidas há 30+ dias',
  overdue8to30: 'Vencidas há 8–29 dias',
  overdue1to7: 'Vencidas há 1–7 dias',
  relOverdue: '{{days}}d em atraso',
  relToday: 'Vence hoje',
  relInDays: 'Em {{days}}d',
  noBills3Days: 'Nenhuma conta vence nos proximos 3 dias',
  billDueLabel: 'Vencimento: ',
  trendsHeading: 'Tendencias de Gastos',
  trendsLoading: 'Carregando tendencias...',
  trendsNoData: 'Nenhum dado de gastos disponivel',
  trendsTotal: 'Total: ',
  trendsSpending: 'Gastos',
  trendsPaid: 'Pago',
  trendsUnpaid: 'Pendente',
  categoryHeading: 'Gastos por Categoria - {{month}}',
  categoryLoading: 'Carregando distribuicao...',
  categoryNoData: 'Nenhum dado de gastos para este mes',
  categoryTotalSpent: 'Total Gasto',
  incomeVsExpensesHeading: 'Receitas vs Despesas',
  incomeVsExpensesLoading: 'Carregando dados de receitas...',
  incomeVsExpensesIncome: 'Receitas',
  incomeVsExpensesExpenses: 'Despesas',
  markBillPaid: 'Marcar como pago',
  statMonthTotal: 'Total do mês',
  statPaid: 'Pago',
  statPending: 'Pendente',
  statOverdueHint: 'Inclui despesas que já venceram e estão em atraso',
  kpiOverdue: 'Atrasadas',
  kpiDueSoon: 'A vencer (3 dias)',
  kpiBillsCount_one: '{{count}} conta',
  kpiBillsCount_other: '{{count}} contas',
} as const;
